/**
 * 试骑图标
 */
const TestRideIcon = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.75 1.875H5.78125L7.62753 3.50825M16.25 1.875H14.375L12.3157 3.50825M7.64647 4.10523L6.09375 4.6875L4.84375 14.8438L7.96875 15.625M12.4158 4.13858L14.0625 4.6875C14.0625 4.6875 14.1202 5.21395 14.1827 5.78425L15.1874 13.7019L15.2348 14.1346L15.3125 14.8438L12.1875 15.558"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="square"
      />
      <circle cx="10" cy="4.0625" r="2.1875" stroke="currentColor" strokeWidth="1.25" />
      <rect
        x="8.125"
        y="11.875"
        width="3.75"
        height="6.25"
        rx="1.875"
        stroke="currentColor"
        strokeWidth="1.25"
      />
    </svg>
  )
}

export default TestRideIcon
